import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UserVideoComponent } from '../../../user/user-video/user-video.component';
import { WharehouseExit2Component } from '../../../wharehouse-reception/wharehouse-exit2/wharehouse-exit2.component';
import { MessageService } from '../../../service/message/message.service';
import { InvoiceSaleDetaileComponent } from '../../../wharehouse-invoice-sale/invoice-sale-detaile/invoice-sale-detaile.component';
import { ProfitReportDetaileComponent } from '../profit-report-detaile/profit-report-detaile.component';

@Component({
  selector: 'app-profit-report-list',
  templateUrl: './profit-report-list.component.html',
  styleUrls: ['./profit-report-list.component.scss']
})
export class ProfitReportListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public show_excel: boolean = false;
  public indeterminate: boolean = false;
  public checked: boolean = false;
  public count_total: number = 1;
  public page: number = 1;
  public excel: number = 1;
  public sum_profit: number = 0;
  public discount_all: number = 0;
  public asc_desc: string = 'asc';
  public order!: string;
  public list_record: any = [];
  public search_array: any = [];
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public site!: string;
  public no_record!: string;
  public user_id!: number;
  public page_number_first!: number;
  public page_number_second!: number;
  public code!: any;
  public export_code!: string;
  public search_all!: string;
  public sum_profit_for_persenel!: number;
  public sum_profit_sale_order!: number;
  public sum_amount_sale!: number;
  public path_export!: string;
  public id!: number;
  public pre_status!: boolean;
  public next_status!: boolean;
  public new_status!: boolean;
  public status_id!: number;
  public title!: string;
  public creator!: number;
  public video!: string;
  public type_load: string = 'all';
  public access_service!: number;
  public level!: number;
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource: any | undefined;
  public displayedColumns = ['row', 'date', 'material_type', 'material', 'customer', 'user', 'place', 'number', 'cost', 'profit', 'percent', 'porsant2', 'profit_sale_order', 'discount', 'update_record'];
  //************** */
  constructor(
    public serverService: ServerService,
    public router: Router,
    public messageService: MessageService,
    public activatedRoute: ActivatedRoute,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public dialogRef: MatDialog) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.site = this.serverService.get_site();
    this.no_record = this.serverService.no_record();
  }
  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    );
    this.activatedRoute.queryParams.subscribe(
      (params: Params) => {
      }
    )
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.serverService.status1(2);
    this.check_access(4, 1, 0, 1, 1);
    //**************
  }//end ngOnInit
  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.path_export = res['path_export'];
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    var obj = {
      'address': 6,
      'user_id': this.creator,
      'id': this.code,
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.title = res['result'][0].title;
          this.video = res['result'][0].video;
          this.loading = false;
          if (type_task == 3) {
          }
          if (type_task == 4) { this.load_data(page, excel, loading, -1); }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  sort(sort: string, asc_desc: string) {
    if (asc_desc == 'asc') this.asc_desc = 'desc';
    else this.asc_desc = 'asc';
    this.order = sort + " " + this.asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  reset_sort(sort: string, asc_desc: string) {
    this.order = sort + " " + asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  load_data2(type: string) {
    this.type_load = type;
    this.load_data(1, 1, 1, -1);
  }
  load_data(page: number, excel: number, loading: number, changedRows: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    if (page == 1) { this.page = 1; }
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    var obj = {
      'address': 7271,
      "page": this.page,
      'excel': excel,
      'user_id': this.user_id,
      'search': this.search_array,
      'search_all': this.search_all,
      'changedRows': changedRows,
      'creator': this.creator,
      'path_export': this.path_export,
      'order': this.order,
      'type_load': this.type_load
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              for (var i = 0; i < res['num']; i++) {
                res['result'][i].loading = false;
                this.list_record.push(res['result'][i]);
              }//end for
            }
            this.discount_all = res['sum_discount'];
            this.sum_profit = res['sum_profit'];
            this.sum_profit_for_persenel = res['sum_profit_for_persenel'];
            this.sum_profit_sale_order = res['sum_profit_sale_order'];
            this.sum_amount_sale = res['sum_amount_sale'];
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.pages(0);
            this.serverService.change_window_resize(2, '', 0);
            this.serverService.send_services_id(this.code);
            this.serverService.send_reset({});
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  //***************************************************************************
  open_detaile(i: number, type_task: number, id: number): any {
    const dialogRef = this.dialog.open(ProfitReportDetaileComponent, {
      width: '30rem',
      height: 'auto',
      disableClose: true,
      data: {
        type_task: type_task,
        id: id,
        i: i,
        search_array: this.search_array,
        code: this.code,
        title: this.title,
        creator: this.creator
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (type_task == 1) {
          }
          else if (type_task == 2) {
          }
          else if (type_task == 3) {
            this.search_array = [];
            this.search_array = res;
            this.check_access(4, 1, 0, 1, 1);
          }
        }
      }
    )
  }
  open_ref(i: number, ref: string) {
    var id = this.list_record[i].ref_id;
    if (ref == 'reception') {
      this.dialog.open(WharehouseExit2Component, {
        width: '85rem',
        height: 'auto',
        disableClose: true,
        data: {
          'reception_id': id,
          'code': this.code,
          'creator': this.creator,
          'readonly': true,
        }
      });
    }
    else if (ref == 'invoice_sale') {
      this.dialog.open(InvoiceSaleDetaileComponent, {
        width: '85rem',
        height: 'auto',
        disableClose: true,
        data: {
          'id': id,
          'code': this.code,
          'creator': this.creator,
          'type_task': 2,
          'readonly': true,
        }
      });
    }
  }
  update_record(i: number, id: number) {
    var material_type = this.list_record[i].wharehouse_order_material_type;
    var ref = this.list_record[i].ref;
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.list_record[i].loading = true;
    var address;
    if (ref == 'reception') {
      if (material_type == 1) address = 7272;
      else if (material_type == 2) address = 7273;
    }
    else {
      if (material_type == 1) address = 7275;
      else if (material_type == 2) address = 7274;
    }
    var obj = {
      'address': address,
      'order_id': id,
      'creator': this.creator,
      'user_id': this.user_id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.list_record[i].wharehouse_order_profit_sale_order = res['result'][0].wharehouse_order_profit_sale_order;
            this.list_record[i].wharehouse_order_profit_sale_order_for_persenel = res['result'][0].wharehouse_order_profit_sale_order_for_persenel;
            this.list_record[i].wharehouse_order_profit = res['result'][0].wharehouse_order_profit;
            this.list_record[i].wharehouse_order_discount = res['result'][0].wharehouse_order_discount;
            this.list_record[i].wharehouse_order_number = res['result'][0].wharehouse_order_number;
            this.list_record[i].wharehouse_order_cost = res['result'][0].wharehouse_order_cost;
            this.list_record[i].profit = res['result'][0].profit;
          }
          this.list_record[i].loading = false;
          this.message(true, this.messageService.message('آپدیت شد'), 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_bg(id: number) {
    this.id = id;
  }
  //*******************************************************************************
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize

  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

